import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { ProcessStep } from '../../common/enums/enums';
import ProgressBar from '../ProgressBar';

const CounterCompleted = ({ total, countCompleted }) => (
  <Typography variant="body2" sx={{ textWrap: 'nowrap' }}>
    {countCompleted} of {total}
  </Typography>
);

export default function WOCompletes({ order }) {
  const theme = useTheme();
  const isMediumSizeBreakPoint = useMediaQuery(theme.breakpoints.down('lg'));
  const countCompleted = order.relatedOrders.filter(
    relatedOrder => relatedOrder.step === ProcessStep.DONE
  ).length;
  const countWithoutCanceledAndDeclined = order.relatedOrders.filter(
    relatedOrder =>
      relatedOrder.step !== ProcessStep.CANCELED &&
      relatedOrder.step !== ProcessStep.DECLINED
  ).length;
  return (
    <>
      <Stack direction="row" gap={1} alignItems="center">
        {!isMediumSizeBreakPoint && (
          <CounterCompleted
            total={countWithoutCanceledAndDeclined}
            countCompleted={countCompleted}
          />
        )}
        <Stack
          flexGrow={2}
          sx={{
            position: {
              sm: 'absolute',
              md: 'unset',
            },
            width: {
              sm: '200px',
              md: 'unset',
            },
            right: {
              sm: '2rem',
              md: 'unset',
            },
          }}
        >
          <ProgressBar
            progressValue={countCompleted / countWithoutCanceledAndDeclined}
          />
        </Stack>
        {isMediumSizeBreakPoint && (
          <CounterCompleted
            total={countWithoutCanceledAndDeclined}
            countCompleted={countCompleted}
          />
        )}
      </Stack>
    </>
  );
}
